import React, { useState } from 'react';
import Topbar from '../components/Topbar';
import CategoriasSection from '../components/sections/CategoriasSection';
import PublicidadSection from '../components/sections/PublicidadSection';
import EditorialSection from '../components/sections/EditorialSection';
import RevistasSection from '../components/sections/RevistasSection';
import PopupSection from '../components/sections/PopupSection';

const TABS = [
  { id: 'categorias', label: 'Categorías' },
  { id: 'publicidad', label: 'Imágenes Publicidad' },
  { id: 'editorial', label: 'Editorial' },
  { id: 'revistas', label: 'Ediciones' },
  { id: 'popup', label: 'Aviso Emergente' },
];

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('categorias');

  const renderSection = () => {
    switch (activeTab) {
      case 'categorias':
        return <CategoriasSection />;
      case 'publicidad':
        return <PublicidadSection />;
      case 'editorial':
        return <EditorialSection />;
      case 'revistas':
        return <RevistasSection />;
      case 'popup':
        return <PopupSection />;
      default:
        return <CategoriasSection />;
    }
  };

  const currentTitle = TABS.find((t) => t.id === activeTab)?.label || '';

  return (
    <div className="app-layout">
      <Topbar />
      <div className="main-content">
        <h1 className="page-title">{currentTitle}</h1>

        <div className="tabs">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {renderSection()}
      </div>
    </div>
  );
};

export default Dashboard;
